<template>
  <div class="activityEdit">
    <el-card class="searchCard" shadow="never">
      <div style="margin: 15px 0px">
        <span style="font-size:1.5em;">{{wxName}}</span>
        <i class="el-icon-date" style="margin: 0 10px"></i>
        <span>{{`${startDate.getFullYear()}年${startDate.getMonth()+1}月${startDate.getDate()}日--${endDate.getFullYear()}年${endDate.getMonth()+1}月${endDate.getDate()}日`}}</span></div>
      <el-form class="basicForm" ref="basicForm" :model="basicForm" label-width="120px" label-position="left" :rules="rule_data">
        <el-form-item label="商户号">
          <el-input  class="form-input" v-model="basicForm.merchantId" disabled></el-input>
        </el-form-item>
        <el-form-item label="商户简称">
          <el-input  class="form-input" v-model="basicForm.merchantName" disabled></el-input>
        </el-form-item>
        <el-form-item label="微信商户号" prop="wxSubMchId">
          <el-input  class="form-input" v-model="basicForm.wxSubMchId"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="searchCard" shadow="never">
    <canteen-form ref="canteenForm" v-if="wxActivityId === 'schoolcanteen_001'" :canteenForm="contentForm" @change="changeContentForm"></canteen-form>
    <education-form ref="educationForm" v-if="wxActivityId === 'education_001'" :educationForm="contentForm" @change="changeContentForm"></education-form>
    </el-card>
    <el-card class="searchCard" shadow="never">
      <el-form ref="otherForm" :model="otherForm" label-width="165px" label-position="left">
        <el-form-item label="补充说明">
          <el-input  class="form-input" v-model="otherForm.additionalMessage"></el-input>
        </el-form-item>
        <el-form-item>
          <template slot="label"><div>补充材料</div><span>(选填，最多5张)</span></template>
          <multi-upload :value="otherForm.additionalPicUrls" valueName="additionalPicUrls" :limit="5"  @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>
        </el-form-item>
        <el-form-item>
          <auth-button
            opt="submit"
            @click.native="onSubmit(false)"
            :loading="updateLoading"
            label="提交"></auth-button>
          <auth-button
            opt="submit"
            @click.native="onSubmit(true)"
            :loading="saveLoading"
            label="保存草稿"></auth-button>
          <auth-button
            opt="close"
            type="primy"
            @click.native="onClose"
            label="关闭"></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import multiUpload from '@/components/upload/multiUpload'
import canteenForm from '../component/canteenForm'
import educationForm from '../component/educationForm'
import qs from 'qs'
import { getSignInfo, submitSignInfo } from '@/api/activity'

export default {
  components: {
    multiUpload,
    canteenForm,
    educationForm
  },
  data () {
    return {
      wxActivityId: '',
      wxName: '',
      basicForm: {
        merchantId: '',
        merchantName: '',
        wxSubMchId: ''
      },
      // 后端处理
      contentForm: {
      },
      // imgArray
      otherForm: {
        additionalMessage: '',
        additionalPicUrls: ''
      },
      status: 0, // -1 未审核 0 审核中 1 审核通过 2 审核失败
      updateLoading: false,
      saveLoading: false,
      rule_data: {
        wxSubMchId: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入微信子商户号'))
            } else {
              if (!(/^\d+$/.test(value))) {
                callback(new Error('微信商户号不符合规范，请检查重试'))
              } else {
                callback()
              }
            }
          },
          required: true
        }]
      },
      startDate: new Date('2021-01-01'),
      endDate: new Date('2021-12-31')
    }
  },
  mounted () {
    this.contentForm = {}
    let data = {}
    if (JSON.stringify(this.$route.query) !== '{}') {
      const query = this.$route.query
      data = qs.stringify({
        id: query.id
      })
      localStorage.setItem('wechatActivitySignQuery', JSON.stringify(query))
    } else if (localStorage.getItem('wechatActivitySignQuery') !== '') {
      const query = JSON.parse(localStorage.getItem('wechatActivitySignQuery'))
      this.merchantId = query.id
      data = qs.stringify({
        id: query.id
      })
    } else {
      this.$router.back()
      return
    }
    getSignInfo(data).then((data) => {
      if (parseInt(data.error_code) === 0) {
        this.basicForm.merchantId = data.data.merchantId
        this.basicForm.merchantName = data.data.merchantName
        this.basicForm.wxSubMchId = data.data.wxSubMchId
        this.otherForm.additionalMessage = data.data.additionalMessage
        this.otherForm.additionalPicUrls = data.data.additionalPicUrls
        this.wxActivityId = data.data.wxActivityId
        this.activityId = data.data.activityId
        this.wxName = data.data.wxName
        const { merchantId, merchantName, wxSubMchId, activityType, wxActivityId, agentId, wxName, additionalPicUrls, additionalMessage, activityId, ...contentForm } = data.data
        if (this.wxActivityId === 'schoolcanteen_001') {
          this.contentForm = {
            canteenDoorPhotos: contentForm.canteenDoorPhotos || '',
            coopQualiProof: contentForm.coopQualiProof || '',
            diningEnvironmentPhotos: contentForm.diningEnvironmentPhotos || '',
            preferRateCommitLetter: contentForm.preferRateCommitLetter || '',
            schoolQualiProof: contentForm.schoolQualiProof || ''
          }
        }
        if (this.wxActivityId === 'education_001') {
          this.contentForm = {
            qualificationProofs: contentForm.qualificationProofs || '',
            // schoolLicenseProofs: contentForm.schoolLicenseProofs || '',
            storeTenancyProofs: contentForm.storeTenancyProofs || '',
            storeDoorPhotos: contentForm.storeDoorPhotos || ''
          }
        }
        this.status = data.data.status // -1 未审核审核失败 0 审核中 1 审核通过 2 审核失败
        this.startDate = new Date(data.data.startDate)
        this.endDate = new Date(data.data.endDate)
      } else {
        this.$message({
          showClose: true,
          message: data.error_msg,
          type: 'warning'
        })
      }
    })
  },
  methods: {
    // 批量上传成功回调
    multiUploaded (data) {
      if (!this.otherForm[data.valueName]) {
        this.otherForm[data.valueName] = data.path
      } else {
        this.otherForm[data.valueName] += ',' + data.path
      }
    },
    // 批量上传删除某一张回调
    multiDelete (data) {
      if (this.otherForm[data.valueName].indexOf(',' + data.path) >= 0) {
        this.otherForm[data.valueName] = this.otherForm[data.valueName].replace(',' + data.path, '')
      } else {
        this.otherForm[data.valueName] = this.otherForm[data.valueName].replace(data.path, '')
      }
      if (this.otherForm[data.valueName].indexOf(',') === 0) {
        this.otherForm[data.valueName] = this.otherForm[data.valueName].substring(1)
      }
    },
    changeContentForm (data) {
      console.log(JSON.stringify(this.contentForm))
      console.log('change content', data)
      this.contentForm = data
    },
    onClose () {
      this.contentForm = {}
      this.$router.push('/Activity/ActivitySignin/wechatActivitySign')
    },
    checkContentFormValid () {
      let validFlag = true
      if (this.wxActivityId === 'schoolcanteen_001') {
        this.$refs.canteenForm.$refs.canteenForm.validate((valid) => {
          validFlag = valid
        })
      }
      if (this.wxActivityId === 'education_001') {
        this.$refs.educationForm.$refs.educationForm.validate((valid) => {
          validFlag = valid
        })
      }
      return validFlag
    },
    onSubmit (isDraft) {
      let formValid = false
      this.$refs.basicForm.validate((valid) => {
        formValid = valid
      })
      const validFlag = this.checkContentFormValid()
      if (isDraft) {
        this.saveLoading = true
        let id = ''
        if (JSON.stringify(this.$route.query) !== '{}') {
          id = this.$route.query.id
        } else if (localStorage.getItem('wechatActivitySignQuery') !== '') {
          const query = JSON.parse(localStorage.getItem('wechatActivitySignQuery'))
          id = query.id
        }
        const data = qs.stringify({
          id: id,
          wxActivityId: this.wxActivityId,
          activityId: this.activityId,
          ...this.basicForm,
          ...this.contentForm,
          ...this.otherForm,
          isDraft
        })
        submitSignInfo(data).then((data) => {
          if (parseInt(data.error_code) === 0) {
            this.saveLoading = false
            this.$message({
              type: 'success',
              message: data.error_msg
            })
          } else {
            this.saveLoading = false
            this.$message({
              showClose: true,
              type: 'error',
              message: data.error_msg
            })
          }
        })
      } else {
        if (formValid && validFlag) {
          this.updateLoading = true
          let id = ''
          if (JSON.stringify(this.$route.query) !== '{}') {
            id = this.$route.query.id
          } else if (localStorage.getItem('wechatActivitySignQuery') !== '') {
            const query = JSON.parse(localStorage.getItem('wechatActivitySignQuery'))
            id = query.id
          }
          const data = qs.stringify({
            id: id,
            wxActivityId: this.wxActivityId,
            activityId: this.activityId,
            ...this.basicForm,
            ...this.contentForm,
            ...this.otherForm,
            isDraft
          })
          submitSignInfo(data).then((data) => {
            if (parseInt(data.error_code) === 0) {
              this.updateLoading = false
              this.$message({
                type: 'success',
                message: data.error_msg
              })
              this.$router.push('/Activity/ActivitySignin/WechatActivitySign')
              this.contentForm = {}
            } else {
              this.updateLoading = false
              this.$message({
                showClose: true,
                type: 'error',
                message: data.error_msg
              })
            }
          })
        } else {
          this.$message({
            showClose: true,
            message: '活动必填资料有误或不完整，请完善后再进行报名',
            type: 'warning'
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .activityEdit {
    padding-left: 20px;
    padding-top: 10px;
  }
  /deep/ .basicForm .el-form-item__label{
    font-size: 16px;
  }
  /deep/.activityEdit {
    .el-form-item__label {
      text-align: left;
    }
  }
  .activityData {
    padding:20px
  }
  .form-input {
    width: 450px;
  }
  .flex {
    display:flex
  }
  .mid {
    height:66px;
    line-height:66px;
    margin-left:10px
  }
  .photos-content-view {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .photos-content-view .el-form-item{
    margin-right: 40px;
    width: 200px;
    text-align: center;
  }
  .photos-content-view {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }
</style>
<style>
  .el-tabs__item.is-active {
    font-size: 18px;
  }
</style>
